import { kebabCase } from "lodash";

/**
 * @param name {string}
 * @returns {{
 *  apply: () => void,
 *  main?: string,
 *  hover?: string,
 *  light?: string,
 *  lightHover?: string,
 *  danger?: string,
 *  dangerLight"?: string,
 *  bg?: string,
 *  white?: string,
 *  black?: string,
 *  text?: string,
 * }}
 */
export function loadColorTemplate(temp) {
  const template = {
    ...temp,
  };
  if (!template) return null;

  template.apply = function () {
    window["colorTemplate"] = template;

    for (const colorName in template) {
      const colorHex = template[colorName];
      const rootStyles = document.querySelector(":root").style;

      if (colorHex) {
        rootStyles.setProperty(`--${kebabCase(colorName)}`, colorHex);
      }
    }
  };

  return template;
}



// WEBPACK FOOTER //
// ./src/styles/templates/index.js